/* global zzl */
import Dialog from '../ui/Dialog'
import DialogButton from '../ui/DialogButton'
import View from '../View'
import DOM from '../dom/DOM'
import DOMUtil from '../dom/DOMUtil'
import ImageUploader from '../uploads/ImageUploader'

const EE = DOM.create

const MaxSize = 1600
const errorDialog = new Dialog('写真を追加できません', '', DialogButton.OK)

function PictureItem (obj, group) {
	var me = this

	me.id = View.register(me)
	me.parentView = null
	me.data = {
		uid_pc: null,
		type_pc: null,
		name_pc: null,
		size_pc: null,
		width_pc: null,
		height_pc: null,
		uid_sp: null,
		type_sp: null,
		name_sp: null,
		size_sp: null,
		width_sp: null,
		height_sp: null,
		caption: '',
		alt: '',
		break_point_sp: '799px',
		break_point_pc: '800px',
		link_url: '',
		link_target: null
	}
	me.dom = null
	me.textarea = null
	me.uploader = null
	me.initView.apply(me, arguments)
}

View.registerClass('PictureItem', PictureItem, {

	createDOM () {
		const { id, data } = this

		this.filePcInput = EE('input', {
			type: 'file',
			accept: 'image/*',
			title: '配置する画像を選択します',
			tabIndex: '-1',
			'bs-ed-var': 'file_pc'
		})
		this.fileSpInput = EE('input', {
			type: 'file',
			accept: 'image/*',
			title: '配置する画像を選択します',
			tabIndex: '-1',
			'bs-ed-var': 'file_sp'
		})
		this.textarea = EE('textarea.bs-ed-input-tr.ccap', {
			placeholder: 'キャプション...',
			'bs-ed-var': 'caption'
		}, [data.caption])
		this.pcPictureItem =EE(`div.cimg${data.uid_pc? '.has-img' : ''}`, {}, [
			EE('label.cthumb.bs-ed-drop-target', {}, [
				this.filePcInput,
				EE('img.img.img-pc', {
					alt: '',
					src: data.uid_pc ? (zzl.uploadImagePrefix + data.uid_pc) : ''
				}),
				EE('span.placeholder', {}, ['画像を選択'])
			]),
			EE('button.cimgrm.bs-ed-act', {
				tabIndex: '-1',
				'data-act': 'removeConfirm'
			}, [
				EE('span.bs-ed-icon.bs-ed-icon-remove', { title: 'この画像を削除する' })
			])
		])
		this.spPictureItem =EE(`div.cimg${data.uid_sp? '.has-img' : ''}`, {}, [
			EE('label.cthumb.bs-ed-drop-target', {}, [
				this.fileSpInput,
				EE('img.img.img-sp', {
					alt: '',
					src: data.uid_sp ? (zzl.uploadImagePrefix + data.uid_sp) : ''
				}),
				EE('span.placeholder', {}, ['画像を選択'])
			]),
			EE('button.cimgrm.bs-ed-act', {
				tabIndex: '-1',
				'data-act': 'removeConfirm'
			}, [
				EE('span.bs-ed-icon.bs-ed-icon-remove', { title: 'この画像を削除する' })
			])
		])

		const dom = EE('div.bs-ed-view.bs-ed-view-PictureItem', { id }, [
			EE('div',{},['PC画像']),
			this.pcPictureItem,
			EE('div',{},['SP画像']),
			this.spPictureItem,
			EE('div.ctool', {}, [
				this.textarea,
				EE('button.settings.bs-ed-act', {
					title: '画像設定',
					tabIndex: '-1',
					'data-act': 'openSettings'
				}, [
					EE('span.bs-ed-icon.bs-ed-icon-cog')
				])
			])
		])
		if (data.link_url) {
			dom.classList.add('has-link')
		}

		setTimeout(() => DOMUtil.adjustHeight(this.textarea))

		return dom
	},

	getUploads () {
		return [...this.getUploadPcs(),...this.getUploadSps()]
	},

	getUploadPcs () {
		return this.data.uid_pc ? [this.data.uid_pc] : []
	},
	getUploadSps () {
		return this.data.uid_sp ? [this.data.uid_sp] : []
	},

	// DOM 部品からの変更通知
	onUpdate (key, value, event) {
		var me = this
		PictureItem.__super__.onUpdate.apply(me, arguments)
		if (key === 'file_pc' || key === 'file_sp') {
			if (event && event.target && event.target.files && event.target.files[0]) {
				me.addUpload(event.target.files[0],key)
			}
			me.resetFileInput(key)
		}
		if (key === 'caption' && me.textarea) {
			DOMUtil.adjustHeight(me.textarea)
		}
	},

	// DOM からのドロップ通知
	onDrop (event) {
		var me = this; var dataTransfer
		dataTransfer = event.originalEvent ? event.originalEvent.dataTransfer : event.dataTransfer
		if (!dataTransfer) {
			return
		}
		event.preventDefault()
		if (dataTransfer.files && dataTransfer.files[0]) {
			me.addUpload(dataTransfer.files[0])
		}
	},

	// <input type="image"> の値を消去して次の入力に備える
	resetFileInput (key) {
		var fileInput = this.dom.querySelector(`input[type='file'][bs-ed-var='${key}']`)
		fileInput.value = ''
	},

	addUpload (file,file_key) {
		var me = this
		me.dom.classList.remove('error')
		me.uploader = new ImageUploader({
			file,
			complete: res => me.uploadComplete(res,file_key),
			error: err => me.uploadError(err),
			maxSize: MaxSize
		})
	},

	destroy () {
		this.uploader = null
	},

	uploadComplete (data,file_key) {
		var me = this; var key
		const pc_tag = '_pc'
		const sp_tag = '_sp'
		const file_type = file_key === 'file_pc' ? pc_tag : sp_tag;
		const key_reg = new RegExp(file_type + '$')
		for (key in me.data) {
			const data_key = key.replace(key_reg, '')

			if (Object.prototype.hasOwnProperty.call(me.data, key) && data[data_key] != null && ((!key.includes(pc_tag) && !key.includes(sp_tag)) || key.includes(file_type))) {
				me.data[key] = data[data_key]
			}
		}
		if (me.data.uid_pc && file_type === pc_tag) {
			me.pcPictureItem.classList.add('has-img')
			me.dom.querySelector('.img-pc').src = zzl.uploadImagePrefix + me.data.uid_pc
		}
		if (me.data.uid_sp && file_type === sp_tag) {
			me.spPictureItem.classList.add('has-img')
			me.dom.querySelector('.img-sp').src = zzl.uploadImagePrefix + me.data.uid_sp
		}
		me.parentView.notifyChange()
	},

	uploadError (message) {
		var me = this
		me.dom.classList.add('error')

		if (!errorDialog.isShown) {
			errorDialog.setSubtitle(localizeErrorMessage(message))
			errorDialog.show()
		}
	},

	remove () {
		var me = this
		if (typeof me.parentView.removePicture === 'function') {
			me.parentView.removePicture(me)
		}
	},

	removeConfirm () {
		var me = this
		if (typeof me.parentView.removePictureConfirm === 'function') {
			me.parentView.removePictureConfirm(me)
		}
	},

	openSettings () {
		var me = this
		const { data } = this

		const newWindowCheckbox = EE('input.field-link_target', {
			type: 'checkbox',
			name: 'newWindow'
		})
		if (data.link_target === '_blank') {
			newWindowCheckbox.checked = true
		}

		const dialogContent = DOM.fragment([
			EE('div.bs-ed-form-group', {}, [
				EE('div.bs-ed-form-label', {}, ['代替テキスト']),
				EE('div.bs-ed-form-controls', {}, [
					EE('input.bs-ed-input.field-alt', { value: data.alt }),
					EE('div.bs-ed-input-desc', {}, ['画像の代わりに読み上げられるテキストです'])
				])
			]),
			EE('div.bs-ed-form-group', {}, [
				EE('div.bs-ed-form-label', {}, ['リンクURL']),
				EE('div.bs-ed-form-controls', {}, [
					EE('input.bs-ed-input.field-link_url', { value: data.link_url }),
					EE('label.bs-ed-checkbox', {}, [
						newWindowCheckbox,
						' 新しいウィンドウで開く'
					])
				])
			]),
			EE('div.bs-ed-form-group', {}, [
				EE('div.bs-ed-form-label', {}, ['ブレイクポイント(PC)']),
				EE('div.bs-ed-form-controls', {}, [
					EE('input.bs-ed-input.field-break_point_pc', { value: data.break_point_pc }),
					EE('div.bs-ed-input-desc', {}, ['PC用画像が表示される最小の画面サイズです'])
				])
			]),
			EE('div.bs-ed-form-group', {}, [
				EE('div.bs-ed-form-label', {}, ['ブレイクポイント(SP)']),
				EE('div.bs-ed-form-controls', {}, [
					EE('input.bs-ed-input.field-break_point_sp', { value: data.break_point_sp }),
					EE('div.bs-ed-input-desc', {}, ['SP用画像が表示される最大の画面サイズです'])
				])
			]),
		])

		const altInput = dialogContent.querySelector('.field-alt')
		const linkInput = dialogContent.querySelector('.field-link_url')
		const breakPointPCInput = dialogContent.querySelector('.field-break_point_pc')
		const breakPointSPInput = dialogContent.querySelector('.field-break_point_sp')

		const dialog = new Dialog('画像設定', dialogContent, DialogButton.OKCancel)
		dialog.on('hide', function (retval) {
			if (retval === 'OK') {
				data.link_url = linkInput.value.trim()
				data.link_target = newWindowCheckbox.checked ? '_blank' : null
				data.break_point_sp = breakPointSPInput.value.trim()
				data.break_point_pc = breakPointPCInput.value.trim()

				me.dom.classList[me.data.link_url ? 'add' : 'remove']('has-link')
				me.parentView.notifyChange()
			}
		})

		dialog.show()
		altInput.focus()
	}


})

const errorMessageFail = 'アップロードに失敗しました'
const errorMessages = [
	[/\b((invalid|unsupported) file type|not an image)\b/i, '対応している画像形式は JPEG, PNG, GIF です'],
	[/\b(network error)\b/i, `${errorMessageFail}。ネットワークに接続されているかご確認ください`],
	[/\b(invalid response)\b/i, `${errorMessageFail}。サーバまたはネットワークで不具合が発生している可能性があります`],
	[/\b(entity too large)\b/i, 'ファイルサイズの上限を超えたためアップロードできませんでした'],
	[/\b(invalid post)\b/i, `${errorMessageFail}。ログイン状態をご確認ください`],
	[/\b(not save file)\b/i, `${errorMessageFail}。サーバで不具合が発生している可能性があります`]
]
function localizeErrorMessage (message) {
	const localized = errorMessages.find(([re, mes]) => re.test(message))
	return localized ? localized[1] : message
}

export default PictureItem
